import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import Members from "../adminComponents/Members";
import DesignationManager from "../adminComponents/DesignationManager";
import AdminGallery from "../adminComponents/AdminGallery";
import AnnouncementAdmin from "../adminComponents/AdminAnnouncements";
import DesignatedMembers from "../adminComponents/DesignatedMembers";
import AdminCreateMember from "../adminComponents/CreateMember";
import EarlyMember from "../adminComponents/EarlyMember";
import BlacklistedMembers from "../BlacklistedMembers";
import PendingMembers from "../adminComponents/PendingMembers";
import Transactions from "../adminComponents/Transactions";
import RenewalsPending from "../adminComponents/RenewalsPending";
import RenewalsFree from "../adminComponents/RenewalsFree";
import { canEditMemberFullProfile } from "../../../Services";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("Members");

  const renderContent = () => {
    switch (activeTab) {
      case "Members":
        return <Members />;
      case "Create Member":
        return <AdminCreateMember />;
      case "Designations":
        return <DesignationManager />;
      case "Designated Members":
        return <DesignatedMembers />;
      case "Announcements":
        return <AnnouncementAdmin />;
      case "Gallery":
        return <AdminGallery />;
      // case "Early Member Verification":
      //   return <EarlyMember />;
      case "Blacklisted Members":
        return <BlacklistedMembers />;
      case "Pending Members":
        return <PendingMembers />;
      case "Transactions":
        return <Transactions />;
      case "Pending Renewals":
        return <RenewalsPending />;
      case "Free Renewals":
        return <RenewalsFree />;
      default:
        return <h3>Welcome to Admin Dashboard</h3>;
    }
  };

  return (
    <Container fluid>
      <Row>
        {/* Sidebar */}
        <Col
          xs={12}
          md={3}
          lg={2}
          className="bg-dark text-light p-3 "
          style={{ minHeight: "100vh" }}
        >
          <h4 className="text-center mb-4">Admin Panel</h4>
          <Nav
            className="flex-column"
            variant="pills"
            activeKey={activeTab}
            onSelect={(selectedKey) => setActiveTab(selectedKey)}
          >
            <Nav.Link eventKey="Members" className="text-light">
              Members
            </Nav.Link>
            <Nav.Link eventKey="Create Member" className="text-light">
              Create Member
            </Nav.Link>
            {canEditMemberFullProfile() && <Nav.Link eventKey="Designations" className="text-light">
              Designations
            </Nav.Link>}
            <Nav.Link eventKey="Designated Members" className="text-light">
              Designated Members
            </Nav.Link>
            <Nav.Link eventKey="Announcements" className="text-light">
              Announcements
            </Nav.Link>
            <Nav.Link eventKey="Gallery" className="text-light">
              Gallery
            </Nav.Link>
            {/* <Nav.Link
              eventKey="Early Member Verification"
              className="text-light"
            >
              Early Member Verification
            </Nav.Link> */}
            <Nav.Link eventKey="Blacklisted Members" className="text-light">
              Blacklisted Members
            </Nav.Link>
            <Nav.Link eventKey="Pending Members" className="text-light">
              Pending Members
            </Nav.Link>
            <Nav.Link eventKey="Transactions" className="text-light">
              Transactions
            </Nav.Link>
            <Nav.Link eventKey="Pending Renewals" className="text-light">
              Renewal Requests
            </Nav.Link>
            <Nav.Link eventKey="Free Renewals" className="text-light">
              Renew Membership
            </Nav.Link>
          </Nav>
        </Col>

        {/* Main Content */}
        <Col xs={12} md={9} lg={10} className="p-4">
          {renderContent()}
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
